import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CopilotPanel } from "./CopilotPanel";
import {
  House, Buildings, MapTrifold, SquaresFour, FlowArrow, UsersThree, Database,
  Cpu, ShieldCheck, Gauge, Target, CalendarBlank, FileText, GearSix, Sparkle, SignOut, FileArrowUp,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Home", icon: House },
  { to: "/organisation", label: "Organisation", icon: Buildings },
  { to: "/documents", label: "Documents", icon: FileArrowUp },
  { to: "/map", label: "Enterprise Map", icon: MapTrifold },
  { to: "/capabilities", label: "Capabilities", icon: SquaresFour },
  { to: "/workflows", label: "Workflows", icon: FlowArrow },
  { to: "/work-roles", label: "Work & Roles", icon: UsersThree },
  { to: "/data", label: "Data", icon: Database },
  { to: "/technology", label: "Technology", icon: Cpu },
  { to: "/governance", label: "Governance", icon: ShieldCheck },
  { to: "/diagnostics", label: "Diagnostics", icon: Gauge },
  { to: "/target-model", label: "Target Model", icon: Target },
  { to: "/roadmap", label: "Roadmap", icon: CalendarBlank },
  { to: "/reports", label: "Reports", icon: FileText },
  { to: "/admin", label: "Administration", icon: GearSix },
];

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [copilotOpen, setCopilotOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#FDFBF7]">
      <aside className="w-60 shrink-0 bg-[#0A0A0A] text-[#FDFBF7] flex flex-col fixed inset-y-0 z-30" data-testid="left-navigation">
        <div className="px-5 pt-6 pb-4 border-b border-white/10">
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">Do The Work</p>
          <h1 className="font-display font-800 text-lg leading-tight tracking-tight mt-1">Enterprise Engineering<br />Navigator<span className="text-[#D4AF37]">™</span></h1>
        </div>
        <nav className="flex-1 overflow-y-auto py-3">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} end={to === "/"} data-testid={`nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `sidebar-link flex items-center gap-3 px-5 py-2 text-[13px] ${isActive ? "bg-white/10 text-[#D4AF37] border-l-2 border-[#D4AF37]" : "text-white/70 hover:bg-white/5 hover:text-white border-l-2 border-transparent"}`}>
              <Icon size={16} weight="duotone" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <button onClick={() => setCopilotOpen(true)} data-testid="open-copilot-btn"
            className="w-full flex items-center justify-center gap-2 bg-[#D4AF37] text-[#0A0A0A] text-[13px] font-semibold py-2 rounded-sm hover:bg-[#e0c258] transition-colors">
            <Sparkle size={15} weight="fill" /> Copilot
          </button>
          <div className="flex items-center justify-between text-[11px] text-white/50">
            <span className="truncate">{user?.name}</span>
            <button onClick={async () => { await logout(); navigate("/login"); }} data-testid="logout-btn"
              className="flex items-center gap-1 hover:text-[#D4AF37] transition-colors"><SignOut size={13} /> Sign out</button>
          </div>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-w-0">
        <Outlet />
      </main>
      <CopilotPanel open={copilotOpen} onClose={() => setCopilotOpen(false)} />
    </div>
  );
}

export function PageHeader({ overline, title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between px-8 pt-8 pb-6">
      <div>
        {overline && <p className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] font-semibold mb-1">{overline}</p>}
        <h1 className="font-display text-3xl font-bold tracking-tight text-[#0A0A0A]">{title}</h1>
        {subtitle && <p className="text-sm text-black/55 mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 shrink-0 pt-2">{actions}</div>}
    </div>
  );
}
